import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { Form } from 'antd';
import React from 'react';
import { BaseForm } from "../../BaseForm";
import { Group, ProFormItem } from "../../components";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
function ProForm(props) {
  return /*#__PURE__*/_jsx(BaseForm, _objectSpread({
    layout: "vertical",
    submitter: {
      // 反转按钮，在正常模式下，按钮应该是主按钮在前
      render: function render(_, dom) {
        return dom.reverse();
      }
    },
    contentRender: function contentRender(items, submitter) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [items, submitter]
      });
    }
  }, props));
}
ProForm.Group = Group;
ProForm.useForm = Form.useForm;
ProForm.Item = ProFormItem;
ProForm.useWatch = Form.useWatch;
ProForm.ErrorList = Form.ErrorList;
ProForm.Provider = Form.Provider;
ProForm.useFormInstance = Form.useFormInstance;
export { ProForm };